<div class="ball"> <span>{{ball.ballNumber}}</span></div>